'use es6';

import PortalIdParser from 'PortalIdParser';
const HTTP_PROTOCOL_REGEX = /^https?:\/\//;
const getBaseUrl = () => '/content-detail';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const addMissingProtocolToUrl = url => {
  if (HTTP_PROTOCOL_REGEX.test(url)) {
    return url;
  }
  return `http://${url}`;
};
export const getIsReferrerUrlValid = (url, portalId) => url.includes(portalId);